module.exports = __webpack_public_path__ + "hbomaxar-static/media/LiquidTrip_SmallLoop_00004.3dec6d05.png";